/**
 * ServiceAlert API Documentation
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SubscriptionType = {
    None: 'None',
    Kvhx: 'KVHX',
    SupplyNumber: 'SupplyNumber'
} as const;
export type SubscriptionType = typeof SubscriptionType[keyof typeof SubscriptionType];

